import { observer } from 'mobx-react';

import { useStores } from '../../../../../stores/useStores';
import { DEFAULT_TIMER } from '../../../../../utils/time';
import { useCountdownTimer } from '../../../hooks';
import { GeneralWidgetTimer } from '../../GeneralWidget';

interface CoinBackWidgetTimerProps {
  endDate: string;
  onEnd: () => void;
  extended?: boolean;
}

function CoinBackWidgetTimerComponent(props: CoinBackWidgetTimerProps) {
  const { extended, onEnd, endDate } = props;
  const { coinBackStore } = useStores();
  const { currentCoinBackBooster, checkIfBoosterActive, isNewPeriodWithCollectables } = coinBackStore;
  const showDefault = isNewPeriodWithCollectables;
  const isBoosterActive = checkIfBoosterActive(currentCoinBackBooster);
  const destinationTime = isBoosterActive && currentCoinBackBooster ? currentCoinBackBooster.endDate : endDate;

  const { timer } = useCountdownTimer({ endDate: destinationTime, onEnd });

  const timerToShow = showDefault ? DEFAULT_TIMER : timer;

  return <GeneralWidgetTimer extended={extended} timerValue={timerToShow} />;
}

export const CoinBackWidgetTimer = observer(CoinBackWidgetTimerComponent);
